import * as React from 'react';
import MuiSlider from '@mui/material/Slider';
import { buildClassName } from 'utils/build-class-name';
import styles from './slider.module.scss';

interface SliderProps {
  id?: string;
  value?: number[];
  onValueChange?: (value: number[]) => void;
  min?: number;
  max?: number;
  step?: number;
  className?: string;
}

const Slider = React.forwardRef<HTMLDivElement, SliderProps>(
  ({ id, className, value = [0], onValueChange, min = 0, max = 100, step = 1 }, ref) => {
    const handleChange = (_event: Event, newValue: number | number[]) => {
      const arrayValue = Array.isArray(newValue) ? newValue : [newValue];
      onValueChange?.(arrayValue);
    };

    return (
      <div className={buildClassName(styles.slider, className)} ref={ref}>
        <MuiSlider
          id={id}
          value={value[0] ?? min}
          onChange={handleChange}
          min={min}
          max={max}
          step={step}
          sx={{
            height: '0.5rem',
            padding: '0.625rem 0',
            color: 'var(--themes-colors-primary-background)',
            '& .MuiSlider-track': {
              border: 'none',
              borderRadius: '9999px',
            },
            '& .MuiSlider-rail': {
              backgroundColor: '#eeeff1',
              opacity: 1,
              borderRadius: '9999px',
            },
            '& .MuiSlider-thumb': {
              height: '1.25rem',
              width: '1.25rem',
              backgroundColor: '#fff',
              border: '2px solid var(--themes-colors-primary-background)',
              transition: 'all 0.2s',
              '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
                boxShadow: 'none',
              },
              '&:focus-visible': {
                outline: '2px solid var(--themes-colors-primary-background)',
                outlineOffset: '2px',
              },
              '&:active': {
                cursor: 'grabbing',
              },
              cursor: 'grab',
            },
          }}
        />
      </div>
    );
  }
);
Slider.displayName = 'Slider';

export { Slider };
